import React, { useEffect, useMemo, useRef, useState } from 'react';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { getDashboardLogin } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";

const SupersetChart = ({
    title,
    height = '400px',
    supersetDomain = process.env.REACT_APP_SUPERSET_DOMAIN,
    config = {}
}) => {
    const containerRef = useRef(null);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const adminData = useSelector((state) => state.adminAuth.adminSessionData);
    const headers = useMemo(() => { return { sessionid: adminData.sessionId }; }, [adminData.sessionId]);

    useEffect(() => {
        if (!adminData?.sessionId || !containerRef.current) {
            return;
        }

        let isCancelled = false;

        const loadChart = async () => {
            try {
                const { token, dashboardId } = await new Promise((resolve, reject) => {
                    getDashboardLogin(headers, dispatch, (response) => {
                        if (response?.result === "SUCCESS") {
                            resolve({
                                token: response?.data?.token,
                                dashboardId: response?.data?.dashboardId
                            });
                        } else {
                            reject(new Error("Failed to fetch chart token"));
                        }
                    });
                });

                if (isCancelled) return;

                await embedDashboard({
                    id: dashboardId,
                    supersetDomain: supersetDomain,
                    mountPoint: containerRef.current,
                    fetchGuestToken: () => token,
                    dashboardUiConfig: {
                        hideTitle: true,
                        hideChartControls: true,
                        ...config
                    },
                });
            } catch (err) {
                if (!isCancelled) {
                    console.error(`Error loading chart :`, err);
                    setError(err.message);
                }
            }
        };

        loadChart();

        return () => {
            isCancelled = true;
        };
    }, [adminData?.sessionId, config, dispatch, headers, supersetDomain]);

    return (
        <div className="superset-chart-container" style={{ width: '100%', height: height, position: 'relative' }}>
            {error ? (
                <div className="flex align-items-center justify-content-center" style={{ height: '100%', color: 'red' }}>
                    Error loading chart: {error}
                </div>
            ) : (
                <div ref={containerRef} style={{ width: '100%', height: '100%' }} />
            )}
        </div>
    );
};

export default SupersetChart;
